// extracted by mini-css-extract-plugin
export default {"main":"_1d2c47a9a2","tit":"_6462cbc690","maintitle":"_43b2f24a31","ylw":"dfaf371640","white":"_4ad618229f","mv_title":"ed8e730759","mv_nc":"_40e430ee03","mv_in":"c482fdf1bd"};